import React, { useMemo } from 'react';
import ExpandedRowCard from '../../../../shared/ui/ExpandedRowCard/ExpandedRowCard';
import { useModalDispatch } from '../../../../shared/lib/toggleModalVisble';
import { createCards } from './utils';
import { showShutdownHistory } from '../../../../features/shutdown';
import { ShutdownAttachments } from '../ShutdownAttachments';
import { useShutdownAccesses } from '../../../../shared/lib/hooks/useShutdownAccesses';
import styles from './ExpandedRow.module.scss';

const { OpenShutdownHistory } = showShutdownHistory;

const ExpandedRow = ({ shutdown }) => {
  const { canChange } = useShutdownAccesses();
  const dispatch = useModalDispatch();

  const cards = useMemo(
    () => createCards({ shutdown, dispatch: canChange ? dispatch : undefined }),
    [dispatch, JSON.stringify(shutdown), canChange]
  );

  return (
    <div className={styles.root}>
      <div className={styles.iconsWrap}>
        <ShutdownAttachments shutdown={shutdown} />
        <OpenShutdownHistory shutdown={shutdown} />
      </div>
      {cards.map((card) => (
        <ExpandedRowCard
          key={card.title}
          {...card}
        />
      ))}
    </div>
  );
};

export default ExpandedRow;
